module.exports = __webpack_public_path__ + "img/icon-map-implantation-04.569e211b.svg";